export default {
    SET_CURRENCIES: 'setCurrencies',
    SET_TARIFFS : 'setTariffs',
    SET_TARIFF_DETAILS : 'setTariffDetails',
    ADD_TARIFF_TYPE : 'addTariffType',
    DELETE_TARIFF : 'deleteTariff',
    SET_TARIFF_NAME: 'setTariffName',
    SET_TARIFFS_NAMES: 'setTariffsNames'
}